import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 16px 0;
  margin: 0 20px;
  border-top: 1px solid ${COLORS.background};
`;

export default Footer;
